// import "jquery-touchswipe/jquery.touchSwipe";
// import "bootstrap";

/* eslint-disable-next-line */
(function ($) {
	$(document).ready(function () {


		const topWaveDividerPath =
			'<path d="M0,17.174S110.281-10.837,358.828-.744,742.4,29.534,994.189,39.626,1366,26.934,1366,26.934V47.445H0Z" transform="translate(0 2.938)"/>';

		const bottomWaveDividerPath =
			'<path d="M1366,27.332s-110.281,28.011-358.828,17.918S623.6,14.973,371.811,4.88,0,17.572,0,17.572V-2.938H1366Z" transform="translate(0 2.938)"/>';

		$(".orange-block.block-divider-wave-ontop").prepend(getBlockDividerHtml("top", topWaveDividerPath, 50.383));
		$(".orange-block.block-divider-wave-onbottom").prepend(getBlockDividerHtml("bottom", bottomWaveDividerPath, 50.383));

		// If the url contains a hash, it might be trying to deep link to a specific tab on the page
		// Scroll to and open the tab if it exists
		// Only applies to tabs inside a Tab block
		if(window.location.hash !== ""){

			const linkedTab = $(".tabs-block-block.has-child-page-tab-content").find(".nav-tabs a[href='" + window.location.hash + "']");

			if(linkedTab.length > 0){

				let scrollPosition = linkedTab.offset().top - (parseInt($("body > header").outerHeight()) + 30);

				if($("#wpadminbar").length > 0){
					scrollPosition -= $("#wpadminbar").outerHeight();
				}

				$("html, body").animate({
					scrollTop: scrollPosition,
				}, 1000);

				linkedTab.click();

			}

		}
		// Updates browser's address bar by adding click tab's ID and a hash value, to simulate page navigation
		$(".tabs-block-block.has-child-page-tab-content").each(function(){

			$(".nav-tabs [data-toggle='tab']", this).on("click", function(){

				const tabId = $(this).attr("href");
				console.log(tabId);

				window.history.pushState(null, null, tabId);

			});

		});

		/**
		 * Carousel - Add active class to first indicator
		 */
		$('.carousel-block .carousel-indicators li:first-of-type').addClass('active');

		/**
		 * Post Slider - Bootstrap mods
		 */
		$('.post-slider .carousel-inner .carousel-item:first-of-type').addClass('active');

		$.each( $('.post-slider-block .post-slider'), function(index, slider) {
			var sliderID = '#' + $(slider).attr('id');
			/*
				CC 2.0 License Iatek LLC 2018 - Attribution required
			*/
			$( this ).on('slide.bs.carousel', function (e) {
				var $e = $(e.relatedTarget);
				var idx = $e.index();
				var itemsPerSlide = 5;
				var totalItems = $(sliderID + ' .carousel-item').length;

				if (idx >= (totalItems - (itemsPerSlide - 1))) {
					var it = itemsPerSlide - (totalItems - idx);
					for (var i = 0; i < it; i++) {

						// append slides to end
						if (e.direction === "left") {
							$(sliderID + ' .carousel-item').eq(i).appendTo(sliderID + ' .carousel-inner');
						} else {
							$(sliderID + ' .carousel-item').eq(0).appendTo(sliderID + ' .carousel-inner');
						}
					}
				}
			});
		});

		function getBlockDividerHtml(location, shapePath, shapeHeight = 50) {

			const dividerHtml =
				'<div class="block-divider-' + location + '">' +
					'<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1366 ' + shapeHeight + '" preserveAspectRatio="none">' +
						'<g fill="var(--' + location + '-divider-color, white)">' + shapePath + '</g>' +
					'</svg>' +
				'</div>';

			return dividerHtml;

		}

		/* Initialize Carousel */
		$('.carousel.ocb').carousel({
			pause: true,
		});

		/* Play trigger */
		$('.carousel-control-cycle-toggle').on("click", function() {

			var state = ($(this).hasClass("oc-pause")) ? 'cycle' : 'pause';

			var carouselId = $(this).closest(".carousel").attr("id");
			
			$("#" + carouselId).carousel(state);

			$(this).toggleClass("oc-pause");

		});


		/**
		 * Video - play video when modal opened
		 */
		$( '.video-block a.video-thumbnail-link' ).on( 'click', function () {
			$( this ).parent().find( 'video' ).trigger('play');
		});


		/**
		 * Testimonial - play/pause functionality
		 */
		/*$( '.testimonial-block a.carousel-control-pause' ).on( 'click', function(){
			var carousel = $( this ).parent().parent().attr( 'id' );

			if( $( this ).hasClass( 'paused' ) ) {
				$( '#' + carousel ).carousel('cycle');
				$( this ).toggleClass( 'paused' );

			} else {
				$( '#' + carousel ).carousel('pause');
				$( this ).toggleClass( 'paused' );
			}
		});*/

		// create function, it expects 2 values.
		/* eslint-disable-next-line */
		function insertAfter(newElement,targetElement) {
			// target is what you want it to go after. Look for this elements parent.
			var parent = targetElement.parent();
			//console.log(parent);

			// if the parents lastchild is the targetElement...
			if (parent.lastChild === targetElement) {
				// add the newElement after the target element.
				parent.appendChild(newElement);
			} else {
				// else the target has siblings, insert the new element between the target and it's next sibling.
				parent.insertBefore(newElement, targetElement.nextSibling);
			}
		}

		//need to change this to a dom listener
		setTimeout(function(){

			if($('#sb_instagram').length){
				var index = 1;
				$('.sbi_item').each(function(){
					var social_container = $('.social-container');
					if(index === 2){


						$(this).after(social_container);
						social_container.removeClass('hidden-unless-required');

					}

					index ++;

				})

			}

		},1000);

		$("#back-to-top").on("click", function () {
			$("html, body").animate({
				scrollTop: 0,
			}, 400);

			return false;
		});

		//scroll
		$(window).scroll(function(){
			if($(this).scrollTop() > 10){
				$('.site-header-wrap').addClass('scrolled');
				$('body').addClass('scrolled');
			}else{
				$('.site-header-wrap').removeClass('scrolled');
				$('body').removeClass('scrolled');
			}
		});


	});
	/* eslint-disable-next-line */
})(jQuery);

